module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia8_thumb-6e20b577ec02f379152cd93c9aa10ba4.jpg";